<div class="button-navigation">
  <ng-container *ngFor="let button of buttons">
    <button *ngIf="button.direction"
            mat-raised-button matStepperNext
            color="primary"
            [gaEvent]="button.gaEvent" gaCategory="buttons_tracking"
            [disabled]="disabled"
            (click)="forwardClickEmitter.emit(true)"
            [routerLink]="['../', button.route]"
            class="stepper-button"
            >
      {{nextButtonLabel ?? button.text}}
      <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon>
    </button>
    <button *ngIf="!button.direction"
            mat-raised-button matStepperPrevious
            [gaEvent]="button.gaEvent" gaCategory="buttons_tracking"
            [routerLink]="['../', button.route]"
            class="stepper-button"
            >
      <mat-icon>arrow_back_ios</mat-icon>
      {{button.text}}
    </button>
  </ng-container>
  <button *ngIf="isLastStep()"
          color="primary"
          mat-raised-button
          gaEvent="add_to_cart" gaCategory="buttons_tracking"
          [routerLink]="['/cos']"
          (click)="forwardClickEmitter.emit(true)"
          class="stepper-button"
  >
    <mat-icon iconPositionEnd>arrow_forward_ios</mat-icon>
    Adauga in cos
  </button>
</div>
